import { render } from "./goalsFormStep2.vue?vue&type=template&id=279af46c&scoped=true"
import script from "./goalsFormStep2.vue?vue&type=script&lang=js"
export * from "./goalsFormStep2.vue?vue&type=script&lang=js"

import "./goalsFormStep2.vue?vue&type=style&index=0&id=279af46c&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279af46c"]])

export default __exports__